import { FC } from "react";
import Link from "next/link";
import { gql } from "@apollo/client";

import Text from "@src/lib/ui/Text";
import TriangleWarningOutlineIcon from "@src/lib/icons/18px/triangle-warning-outline";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";
import { useBillingBannerQuery } from "@src/features/app/AddPaymentMethodBanner.generated";

export const AddPaymentMethodBanner: FC = () => {
  const { userActionPermissions } = useActionPermissions();
  const { data } = useBillingBannerQuery({
    skip: !userActionPermissions?.manageBilling,
  });
  const needsPaymentMethod =
    data &&
    data.BillingAccounts.length > 0 &&
    data.BillingAccounts.filter((ba) => ba.paymentMethod).length === 0;
  if (!data || !needsPaymentMethod || data?.Me?.user?.org?.paysManually) {
    return null;
  }
  return (
    <div className="mt-3 flex shrink-0">
      <Link
        href="/settings/billing"
        className="flex flex-1 items-center justify-center gap-2 self-stretch bg-yellow-2 p-3"
      >
        <TriangleWarningOutlineIcon className="text-yellow-12" />
        <Text variant="compact-title" className="text-yellow-12">
          <span className="underline">Add a payment method</span> to continue
          using Opus
        </Text>
      </Link>
    </div>
  );
};

gql`
  query BillingBanner {
    Me {
      user {
        id
        org {
          id
          paysManually
        }
      }
    }
    BillingAccounts(input: {}) {
      id
      paymentMethod {
        id
      }
    }
  }
`;
